import VueI18n from "vue-i18n";
import { isSupportedLocale, translations, } from "../translations/global";
import { isString, } from "./utilities/wsi4_typeguards";
import { isInstanceOf, } from "./utilities/aux";
export var CurrencyCode;
(function (CurrencyCode) {
    CurrencyCode["EUR"] = "EUR";
    CurrencyCode["USD"] = "USD";
    CurrencyCode["GBP"] = "GBP";
})(CurrencyCode || (CurrencyCode = {}));
export function isCurrrencyCode(s) {
    return s === CurrencyCode.EUR || s === CurrencyCode.USD || s === CurrencyCode.GBP;
}
export function isTranslation(t) {
    const typeGuardMap = {
        placeholder: isString,
        locale: isSupportedLocale,
        translation: isString,
    };
    return isInstanceOf(t, typeGuardMap);
}
export default class I18n extends VueI18n {
    constructor() {
        super({
            locale: "de-DE",
            fallbackLocale: "en-US",
            silentFallbackWarn: true,
            messages: translations,
        });
        this.translationOverwrites = [];
        this.currencyCode = CurrencyCode.EUR;
    }
    t(key) {
        if (!isString(key) || key === "") {
            return "";
        }
        const overwrite = this.translationOverwrites.find(t => t.locale === this.locale && t.placeholder === key);
        if (overwrite !== undefined) {
            return overwrite.translation;
        }
        if (this.messages[this.locale][key] === undefined) {
            throw Error("Missing translation: " + key + "; locale:" + this.locale);
        }
        return super.t(key)
            .toString();
    }
    ta(key, options) {
        if (!isString(key) || key === "") {
            return "";
        }
        if (this.messages[this.locale][key] === undefined) {
            throw Error("Missing translation: " + key + "; locale:" + this.locale);
        }
        return super.t(key, options)
            .toString();
    }
    numberWithTwoDecimals(n) {
        return this.n(n, {
            minimumFractionDigits: "2",
            maximumFractionDigits: "2",
        })
            .toString();
    }
    currencyString(n, priceFactors) {
        return this.n((n * priceFactors.generalFactor) * priceFactors.taxesFactor, { style: "currency", currency: this.currencyCode })
            .toString();
    }
    setLocaleAndCurrency(locale, currency) {
        if (!isSupportedLocale(locale)) {
            throw Error("Locale not supported");
        }
        this.locale = locale;
        if (!isCurrrencyCode(currency)) {
            throw Error("Currency code not supported");
        }
        this.currencyCode = currency;
    }
    overwriteTranslations(translations) {
        for (const t of translations) {
            if (!isSupportedLocale(t.locale)) {
                throw Error("Locale not supported: " + t.locale);
            }
            if (this.messages[t.locale][t.placeholder] === undefined) {
                throw Error("Placeholder not supported: " + t.placeholder);
            }
        }
        this.translationOverwrites = translations;
    }
}
